import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFeedResult } from "../types/Feed/IFeedResult";

const FeedSlice = createSlice({
    name: "count",
    initialState: {
        feedItems: { LastId: 0 } as IFeedResult,
    },
    reducers: {
        SetFeedItems: (state, action: PayloadAction<IFeedResult>) => {
            state.feedItems = action.payload
        }
    },
});

export const { SetFeedItems } = FeedSlice.actions
export default FeedSlice.reducer
